import axios, { AxiosPromise } from 'axios';
import { IColdStorage } from '../../../@types/model/coldStorage/coldStorage';
import { IColdStorageUpsert } from '../../../@types/model/coldStorage/coldStorageUpsert';
import qs from 'qs';
import { IEndColdStorageUpsert } from '../../../@types/model/coldStorage/endColdStorageUpsert';

export default class ColdStorageHttpService {
    public static GetList(storageUnitIds : Array<number>) : AxiosPromise<Array<IColdStorage>> {
        return axios.get(`${API_URL}/v1/ColdStorage/GetAll`, {
            params: { storageUnitIds },
            paramsSerializer: qs.stringify,
        });
    }

    public static GetLatest(storageUnitIds : Array<number>) : AxiosPromise<Array<IColdStorage>> {
        return axios.get(`${API_URL}/v1/ColdStorage/GetLatest`, {
            params: { storageUnitIds },
            paramsSerializer: qs.stringify,
        });
    }

    public static upsert(upsert : IColdStorageUpsert) : AxiosPromise<IColdStorage> {
        return axios.post(`${API_URL}/v1/ColdStorage/Upsert`, upsert);
    }

    public static end(upsert : IEndColdStorageUpsert) : AxiosPromise {
        return axios.post(`${API_URL}/v1/ColdStorage/End`, upsert);
    }

    public static delete(id : number) : AxiosPromise<IColdStorage> {
        return axios.delete(`${API_URL}/v1/ColdStorage/Delete`, {
            params: { id },
        });
    }
}
